import React, { useEffect, useState, useMemo } from "react";
import { blogPosts } from "@/data/blogPosts";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import { ArrowRight } from "lucide-react";



const CATEGORIES = [
  "All",
  "Threat Alerts",
  "Scam Awareness",
  "Enterprise Security",
  "AI Security",
  "Compliance",
  "Digital Safety",
];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState("All");

    useEffect(() => {
        setPosts(blogPosts);
    }, []);

  const filtered = useMemo(
    () => posts.filter((p) => active === "All" || p.category === active),
    [posts, active]
  );

  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow="Threat Intelligence & Resources"
        title="Insights, threat alerts and digital safety stories"
        description="Practitioner-first writing from the Cosmos Defence SOC, awareness and research teams — covering enterprise security, AI defense, scams, compliance and citizen safety."
      />

      <section className="py-16 bg-white">
        <div className="container-cd">
          <div className="flex flex-wrap gap-3 mb-12" data-testid="blog-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`blog-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setActive(c)}
                className={`px-4 py-2 rounded-full text-sm font-display font-semibold transition-all border ${
                  active === c
                    ? "bg-[#0A1B5E] text-white border-[#0A1B5E]"
                    : "bg-white text-slate-600 border-slate-200 hover:border-[#3B82F6] hover:text-[#3B82F6]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p, i) => (
              <Link to={`/blog/${p.id}`} key={p.id} data-testid={`blog-post-${i}`} className="card-cd !p-0 overflow-hidden flex flex-col group">
                <div className="relative h-48 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <span className="absolute top-4 left-4 badge-cd !bg-white">{p.category}</span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="font-mono-tech text-xs uppercase tracking-widest text-slate-400">{p.date} · {p.read_time}</div>
                  <h3 className="mt-3 font-display text-lg font-bold text-[#0A1B5E] leading-snug group-hover:text-[#3B82F6] transition-colors">{p.title}</h3>
                  <p className="mt-2 text-slate-600 text-sm">{p.excerpt}</p>
                  <span className="mt-auto pt-5 inline-flex items-center gap-1 text-[#3B82F6] font-semibold text-sm">
                    Read article <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-16 text-slate-500" data-testid="blog-empty">No articles in this category yet.</div>
          )}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
